import React, { type ReactNode, forwardRef } from 'react';

export interface ButtonProps extends React.ComponentPropsWithRef<'button'> {
  children?: ReactNode;
  className?: string;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { children = undefined, className = undefined, type, ...rest }: ButtonProps,
    ref
  ) => {
    return (
      <button
        ref={ref}
        className={className}
        type={type === 'submit' ? 'submit' : 'button'}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

Button.defaultProps = {
  children: undefined,
  className: undefined
};
